import { remoteConfig } from 'boot/firebase';
import { getBoolean, getNumber, getString, getValue } from 'firebase/remote-config';

export const REMOTE_CONFIG_KEYS = {
  RBT_SESSION_WITHOUT_PROGRAM: {
    key: 'rbt_session_without_program',
    type: 'boolean',
  },
  PROGRESS_LAST_SESSION_DATA_COLUMN: {
    key: 'progress_last_session_data_column',
    type: 'boolean',
  },
  CAMBER_ITEM_BASE_URL: {
    key: 'camber_item_base_url',
    type: 'string',
  },
};

export const REFRESH_INTERVAL = process.env.ENV_TYPE === 'development'
  ? 10 * 60 * 1000 // 10 minutes
  : 10 * 60 * 60 * 1000; // 10 hours

/**
 * @typedef {'boolean' | 'string' | 'number' | 'json'} ConfigValueType
 */

/**
 * Gets a configuration value from Firebase Remote Config.
 *
 * @param {string} key - The key of the config
 * @param {ConfigValueType} [type='boolean'] - The type to which you want to convert the value
 * @returns {boolean|string|number|object|null} The value of the configuration or 'null' if the fetch fails
 * @example const myBooleanValue = fetchConfigValue('my_key');
 * @example const myStringValue = fetchConfigValue('my_key', 'string');
 */
// eslint-disable-next-line import/prefer-default-export
export function getConfigValue(key, type = 'boolean') {
  try {
    switch (type) {
      case 'boolean': {
        return getBoolean(remoteConfig, key);
      }
      case 'string': {
        return getString(remoteConfig, key);
      }
      case 'number': {
        return getNumber(remoteConfig, key);
      }
      case 'json': {
        return JSON.parse(getValue(remoteConfig, key).asString());
      }
      default:
        console.warn(`Unknown config value type: ${type}`);
        return null;
    }
  } catch (error) {
    console.error(`Remote Config fetch failed for key "${key}":`, error);
    return null;
  }
}
